export default "__VITE_PUBLIC_ASSET__d16de7c6__"